var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrickGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 70,
    viewBox: "0 0 73 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10116_26213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5996 68.0408L71.4996 45.5508V17.0508L19.5996 37.8708V68.0408Z",
    fill: "#00963E",
    stroke: "#006A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 53.9393L19.6 68.0593V37.8693L1.5 24.2793V53.9393Z",
    fill: "#00963E",
    stroke: "#006A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5 17.0509L19.6 37.8709L1.5 24.2809L52.14 2.88086L71.5 17.0509Z",
    fill: "#00963E",
    stroke: "#006A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8796 17.4706C32.8796 14.4506 28.5596 11.9206 23.2196 11.8306C17.8796 11.7406 13.5596 14.1106 13.5596 17.1406C13.5596 17.1806 13.5596 17.2106 13.5596 17.2506V23.2806H13.6096C14.0996 26.0506 18.2196 28.2806 23.2196 28.3706C28.2196 28.4606 32.3296 26.3706 32.8296 23.6206H32.8796V17.5906C32.8796 17.5906 32.8796 17.5206 32.8796 17.4806V17.4706Z",
    fill: "#00963E",
    stroke: "#006A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6403 7.08975C60.6403 4.06975 56.3203 1.53975 50.9803 1.44975C45.6403 1.35975 41.3203 3.72975 41.3203 6.75975C41.3203 6.79975 41.3203 6.82975 41.3203 6.86975V12.8997H41.3703C41.8603 15.6697 45.9803 17.8997 50.9803 17.9897C55.9803 18.0797 60.0903 15.9897 60.5903 13.2397H60.6403V7.20975C60.6403 7.20975 60.6403 7.13975 60.6403 7.09975V7.08975Z",
    fill: "#00963E",
    stroke: "#006A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8798 17.0621C32.9562 14.0641 28.6946 11.5236 23.3613 11.3877C18.028 11.2518 13.6425 13.5719 13.5661 16.5698C13.4897 19.5677 17.7513 22.1082 23.0846 22.2442C28.4179 22.3801 32.8034 20.06 32.8798 17.0621Z",
    fill: "#00963E",
    stroke: "#006A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6308 6.68706C60.7072 3.68913 56.4456 1.14863 51.1123 1.0127C45.7789 0.876767 41.3935 3.19688 41.3171 6.19481C41.2407 9.19274 45.5022 11.7332 50.8356 11.8692C56.1689 12.0051 60.5544 9.685 60.6308 6.68706Z",
    fill: "#00963E",
    stroke: "#006A2A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10116_26213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 69.06,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrickGreen);
export default __webpack_public_path__ + "static/media/brickGreen.4fdc25ad1855f46c05a5a39d9af286c7.svg";
export { ForwardRef as ReactComponent };